import { ApiError, isResourceBusyError } from '@/core/api/request'
import i18n from 'i18next'

export function resolveEmailError(error: unknown): string {
  // 同時の書き込みの衝突（#3851）。登録できていないので「登録済み」に読み替えない。
  // XState の assign から呼ばれ t を受け取れないため、i18next の共通インスタンスで翻訳する
  if (isResourceBusyError(error)) {
    return i18n.t('error.resource_busy', '混み合っています。少し時間をおいて、もう一度お試しください。')
  }
  if (error instanceof ApiError) {
    if (error.status === 400) return 'メールアドレスが正しくありません。'
    if (error.status === 409) return 'このメールアドレスはすでに登録されています。'
    if (error.status === 422) return '認証コードが正しくありません。'
    if (error.status === 429) return '送信回数の上限に達しました。しばらく待ってから再試行してください。'
    if (error.status === 401) return 'セッションが切れました。再度ログインしてください。'
    return 'エラーが発生しました。しばらく待ってから再試行してください。'
  }
  if (error instanceof Error) return error.message
  return 'エラーが発生しました。'
}
